import { h } from "omi";

import { IconProps } from "@/wc/components";

export function CalendarIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 20 20">
      <path
        d="M17.5 8.33268h-15m10.8333-6.66666v3.33333M6.66667 1.66602v3.33333M6.5 18.3327h7c1.4001 0 2.1002 0 2.635-.2725.4704-.2397.8528-.6221 1.0925-1.0925.2725-.5348.2725-1.2349.2725-2.635V7.33268c0-1.40013 0-2.10019-.2725-2.63497-.2397-.47041-.6221-.85286-1.0925-1.09254-.5348-.27249-1.2349-.27249-2.635-.27249h-7c-1.40013 0-2.1002 0-2.63498.27249-.4704.23968-.85285.62213-1.09254 1.09254C2.5 5.23249 2.5 5.93255 2.5 7.33268v7.00002c0 1.4001 0 2.1002.27248 2.635.23969.4704.62214.8528 1.09254 1.0925.53478.2725 1.23485.2725 2.63498.2725Z"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
